import React, { useContext, useEffect } from "react";
import { Switch, Route, Link, useHistory, useLocation } from "react-router-dom";

import { CameraContext } from "./contexts/CameraContext";

import HomePage from "./pages/home/Home";
import TakePhotoPage from "./pages/take-photo/TakePhoto";
import ProfilePage from "./pages/profile/Profile";
import LoginPage from "./pages/login/Login";
import SignupPage from "./pages/login/SignupPage";
import TutorialPage from "./pages/tutorial/TutorialPage";
import JobProgressPage from "./pages/job-progress/JobProgressPage";
import ViewerPage from "./pages/viewer/Viewer";
import "./App.scss";
import { ReactComponent as BodyButton } from "./styles/svg-components/body.svg";
import { ReactComponent as HomeButton } from "./styles/svg-components/home.svg";
import { ReactComponent as ScannerButton } from "./styles/svg-components/scanner.svg";
import { ReactComponent as AddIconButton } from "./styles/svg-components/add.svg";

import { LinkButton, Header } from "./components";

import Div100Vh from "react-div-100vh";
import { AuthContext } from "./contexts/AuthContext";
import ResetPassword from "./pages/reset-password/ResetPassword";
import { AcceptProfile } from "./pages/accept-profile/AcceptProfile";
import { DeepLink } from "./pages/link/DeepLink";

const navRoutes = [
  {
    title: "Dashboard",
    to: "/",
    exact: true,
    icon: () => <HomeButton className="link-icon"></HomeButton>,
    color: "#A863FF",
  },
  {
    title: "Body",
    to: "/body",
    icon: () => <BodyButton className="link-icon"></BodyButton>,
    exact: false,
    color: "#FF773B",
  },
  {
    title: "Scanner",
    to: "/take-photo",
    icon: () => <ScannerButton className="link-icon"></ScannerButton>,
    exact: false,
    color: "#1FBEF9",
  },
];

function App() {
  const { isInBodyScanMode } = useContext(CameraContext);
  const { isAuthenticated, isLoading } = useContext(AuthContext);
  const history = useHistory();
  const { pathname } = useLocation();

  const pathWithoutSlashes = pathname.replaceAll("/", "");

  const isLogin = pathWithoutSlashes.startsWith("login");
  const isSignup = pathWithoutSlashes.startsWith("signup");
  const isViewer = pathWithoutSlashes.includes("viewer");
  const isReset = pathWithoutSlashes.startsWith("reset-password");
  const acceptProfile = pathWithoutSlashes.startsWith("AcceptProfile");
  const isLink = pathWithoutSlashes.startsWith("link");

  useEffect(() => {
    if (
      !isAuthenticated &&
      !isLoading &&
      !isViewer &&
      !isSignup &&
      !isReset &&
      !isLink &&
      !acceptProfile
    ) {
      console.log(
        "app !isAuth !isLoading !isViewerPage !isReset, redirect to login"
      );
      history.push("/login");
    }
  }, [isAuthenticated, isLoading, pathname]);


  const showHeader = () =>
    !isInBodyScanMode && !isLogin && !isSignup && !isViewer && !isReset;

  return (
    <Div100Vh
      className={!pathname.startsWith("/viewer") ? "app" : "app viewer"}
    >
      {showHeader() && <Header />}
      <Switch>
        <Route path="/body">
          <ProfilePage />
        </Route>
        <Route path="/take-photo">
          <TakePhotoPage />
        </Route>
        <Route path="/signup">
          <SignupPage />
        </Route>
        <Route path="/tutorial">
          <TutorialPage />
        </Route>
        <Route path="/job/:id">
          <JobProgressPage />
        </Route>
        <Route path="/viewer">
          <ViewerPage />
        </Route>
        <Route path="/reset-password">
          <ResetPassword />
        </Route>
        <Route path="/login">
          <LoginPage />
        </Route>
        <Route path="/AcceptProfile">
          <AcceptProfile scheme={"mm3d://"} />
        </Route>
        <Route path="/AcceptProfileDev">
          <AcceptProfile scheme={"devmm3d://"} />
        </Route>
        <Route path="/AcceptProfileTest">
          <AcceptProfile scheme={"testmm3d://"} />
        </Route>
        <Route path="/Link/:path">
          <DeepLink />
        </Route>
        <Route path="/" exact>
          <HomePage />
        </Route>
        <Route>
          <div>Page not found</div>
        </Route>
      </Switch>
      {showHeader() && (
        <>
          <nav>
            {navRoutes.map((r) => (
              <LinkButton key={r.to} {...r} />
            ))}
          </nav>
          <Link to="/tutorial">
            <button className="create-avatar-button">
              <AddIconButton></AddIconButton>
            </button>
          </Link>
        </>
      )}
    </Div100Vh>
  );
}

export default App;
